export const FETCH_TRANSACTIONS = 'app/Payments/History/FETCH_TRANSACTIONS';
export const FETCH_TRANSACTIONS_FAILURE = 'app/Payments/History/FETCH_TRANSACTIONS_FAILURE';
export const FETCH_TRANSACTIONS_SUCCESS = 'app/Payments/History/FETCH_TRANSACTIONS_SUCCESS';

export const FETCH_TRANSACTION_DETAIL = 'app/Payments/History/FETCH_TRANSACTION_DETAIL';
export const FETCH_TRANSACTION_DETAIL_FAILURE =
  'app/Payments/History/FETCH_TRANSACTION_DETAIL_FAILURE';
export const FETCH_TRANSACTION_DETAIL_SUCCESS =
  'app/Payments/History/FETCH_TRANSACTION_DETAIL_SUCCESS';

export const RESET_PAYMENT_DETAIL_STATE = 'app/Payments/History/RESET_PAYMENT_DETAIL_STATE';

export const RESET_PAYMENT_HISTORY_STATE = 'app/Payments/History/RESET_PAYMENT_HISTORY_STATE';

export const SET_GROUPED_TRANSACTIONS = 'app/Payments/History/SET_GROUPED_TRANSACTION';

export const UPDATE_SELECTED_TRANSACTION = 'app/Payments/History/UPDATE_SELECTED_TRANSACTION';

/* eslint-disable max-len */
export const FETCH_TRANSACTIONS_ERROR_MESSAGE = 'An error has occurred while trying to retrieve your documents. If this issue persists, please call customer service.';
export const FETCH_TRANSACTION_DETAIL_ERROR_MESSAGE = 'Document unavailable at the moment. Please contact Customer Service if this persists.';
export const NO_TRANSACTIONS_MESSAGE = 'No payment history. Please check again after a payment has been made.';

export const MULTIPLE_PAYMENTS = 'Multiple Payments';
export const BANNER_TEXT = {
  detail: 'Questions about this payment? Send a secure message to get in touch with us. ',
  history: 'Questions about a payment? Sending a secure message is a safe and easy way to get in touch with us. ',
};
